import type { LeaderboardEntry } from "./board";

export type Continent = {
  id: string;
  label: string;
};

export const CONTINENTS: Continent[] = [
  { id: "europe", label: "Europe" },
  { id: "asia-pacific", label: "Asia & Pacific" },
  { id: "north-america", label: "North America" },
  { id: "central-south-america", label: "Central & South America" },
  { id: "africa", label: "Africa" },
];

const COUNTRY_CONTINENT: Record<string, string> = {
  France: "europe",
  Austria: "europe",
  Switzerland: "europe",
  Italy: "europe",
  Germany: "europe",
  Spain: "europe",
  Portugal: "europe",
  Andorra: "europe",
  Norway: "europe",
  Sweden: "europe",
  Finland: "europe",
  Iceland: "europe",
  Ireland: "europe",
  "United Kingdom": "europe",
  Bulgaria: "europe",
  Slovakia: "europe",
  "Czech Republic": "europe",
  Poland: "europe",
  Slovenia: "europe",
  Romania: "europe",
  Greece: "europe",
  Turkey: "europe",
  Georgia: "europe",
  Montenegro: "europe",
  Serbia: "europe",
  "North Macedonia": "europe",
  "Bosnia and Herzegovina": "europe",
  "United States": "north-america",
  Canada: "north-america",
  Mexico: "central-south-america",
  "Costa Rica": "central-south-america",
  Nicaragua: "central-south-america",
  Panama: "central-south-america",
  "El Salvador": "central-south-america",
  "Dominican Republic": "central-south-america",
  Jamaica: "central-south-america",
  Barbados: "central-south-america",
  Guadeloupe: "central-south-america",
  "Puerto Rico": "central-south-america",
  Brazil: "central-south-america",
  Peru: "central-south-america",
  Ecuador: "central-south-america",
  Chile: "central-south-america",
  Argentina: "central-south-america",
  Japan: "asia-pacific",
  China: "asia-pacific",
  "South Korea": "asia-pacific",
  Taiwan: "asia-pacific",
  Philippines: "asia-pacific",
  Indonesia: "asia-pacific",
  India: "asia-pacific",
  "Sri Lanka": "asia-pacific",
  Maldives: "asia-pacific",
  Iran: "asia-pacific",
  Lebanon: "asia-pacific",
  Australia: "asia-pacific",
  "New Zealand": "asia-pacific",
  Fiji: "asia-pacific",
  Samoa: "asia-pacific",
  "French Polynesia": "asia-pacific",
  Morocco: "africa",
  Senegal: "africa",
  "Cape Verde": "africa",
  "South Africa": "africa",
  Mozambique: "africa",
  Madagascar: "africa",
  Mauritius: "africa",
  "Réunion": "africa",
};

export function getContinentId(country: string): string | null {
  return COUNTRY_CONTINENT[country] ?? null;
}

export function getContinentLabel(id: string): string | null {
  return CONTINENTS.find((c) => c.id === id)?.label ?? null;
}

export function getAvailableContinents(
  entries: LeaderboardEntry[]
): Continent[] {
  const ids = new Set<string>();
  for (const e of entries) {
    const id = getContinentId(e.country);
    if (id) ids.add(id);
  }
  return CONTINENTS.filter((c) => ids.has(c.id));
}

export function getCountriesForEntries(
  entries: LeaderboardEntry[],
  continentId: string | null
): { code: string; name: string }[] {
  const subset = continentId
    ? entries.filter((e) => getContinentId(e.country) === continentId)
    : entries;

  const seen = new Map<string, string>();
  for (const e of subset) {
    const code = e.countryCode.toLowerCase();
    if (!seen.has(code)) seen.set(code, e.country);
  }

  return [...seen.entries()]
    .map(([code, name]) => ({ code, name }))
    .sort((a, b) => a.name.localeCompare(b.name));
}
